import React from 'react';

import ThreadStream from './ThreadStream';
import ThreadInput from './ThreadInput';

import styles from './ThreadContent.module.css';

const ThreadContent = ({allowEdit = true}) => (
    <main className={styles.main}>
        <ThreadStream/>
        {allowEdit ? <ThreadInput/> : null}
    </main>
);

export default ThreadContent;
